<div class="cg-datatable__top-actions__links">
  <span clas="cg-datatable__top-actions__header">{{ actionHeader }}:</span>
  <ng-container *ngFor="let action of actions; last as lastAction">
    <span
      *ngIf="action.value === selectedAction"
      class="cg-datatable__top-actions__links--selected"
      data-test="table-action-link-selected"
      >{{ action.label }}</span
    >
    <button
      *ngIf="action.value !== selectedAction"
      style="padding: 0;"
      cignaButton="link"
      class="cg-datatable__top-actions__links--unselected"
      (click)="actionChange.emit(action.value)"
      data-test="table-action-link"
    >
      {{ action.label }}
    </button>
    <span *ngIf="!lastAction" class="cg-datatable__top-actions__divider"
      >|</span
    >
  </ng-container>
</div>
